import React, { useState, useEffect, useRef } from "react";
import "./TypeFastWord.css";

const wordList = [
  "elaterid",
  "banausic",
  "myxomatosis",
  "sunglo",
  "quintal",
  "faena",
  "rutilant",
  "halophyte",
  "Pierian",
  "calefacient",
  "brume",
  "dioscuric",
  "tiqueur",
  "netsuke",
  "chatelaine",
  "balalaika",
  "vilipend",
  "fossette",
  "bouilli",
  "dacquoise",
  "sacroiliac",
  "Leith",
  "ontologism",
  "durbar",
  "doxycycline",
  "Eames",
  "palynological",
  "fresnel",
  "larigot",
  "lycopene",
  "sardonyx",
  "logodaedaly",
  "butyraceous",
  "lamina",
  "ballonné",
  "damascened",
  "waiata",
  "gneiss",
  "pulvillus",
  "miombo",
  "tontine",
  "orpharion",
  "frumenty",
  "carnauba",
];

const TypeFastWord = () => {
  const [words, setWords] = useState([]);
  const [gameStarted, setGameStarted] = useState(false);
  const [input, setInput] = useState("");
  const [misses, setMisses] = useState(0);
  const [score, setScore] = useState(0);
  const [gameOver, setGameOver] = useState(false);
  const containerRef = useRef();
  useEffect(() => {
    if (!gameStarted || gameOver) return;

    const interval = setInterval(() => {
      setWords((prev) => {
        const activeWords = prev.map((w) => w.word);
        const availableWords = wordList.filter((w) => !activeWords.includes(w));
        const wordPool = availableWords.length > 0 ? availableWords : wordList;

        const newWord = wordPool[Math.floor(Math.random() * wordPool.length)];

        return [
          ...prev,
          {
            word: newWord,
            y: 0,
            x: Math.random() * 80 + 5,
            id: Date.now() + Math.random(),
          },
        ];
      });
    }, 2000 - Math.min(score * 30, 1500));

    return () => clearInterval(interval);
  }, [score, gameStarted, gameOver]);

  useEffect(() => {
    if (!gameStarted || gameOver) return;

    const interval = setInterval(() => {
      setWords((prevWords) => {
        const updated = prevWords.map((w) => ({ ...w, y: w.y + 4 }));
        const containerHeight = containerRef.current?.offsetHeight || 600;

        const fallen = updated.filter((w) => w.y > containerHeight);
        if (fallen.length > 0) {
          setMisses((prev) => prev + fallen.length);
        }

        return updated.filter((w) => w.y <= containerHeight);
      });
    }, 100);

    return () => clearInterval(interval);
  }, [gameStarted, gameOver]);

  // Check for correct input
  //   useEffect(() => {
  //     if (input === "") return;

  //     setWords((prev) => {
  //       const index = prev.findIndex((w) => w.word === input.toUpperCase());
  //       if (index !== -1) {
  //         setScore((s) => s + 1);
  //         const newWords = [...prev];
  //         newWords.splice(index, 1);
  //         setInput("");
  //         return newWords;
  //       }
  //       return prev;
  //     });
  //   }, [input]);
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      const typedWord = input.trim().toLowerCase();

      setWords((prev) => {
        const index = prev.findIndex((w) => w.word.toLowerCase() === typedWord);
        if (index !== -1) {
          setScore((s) => s + 1);
          const newWords = [...prev];
          newWords.splice(index, 1);
          setInput("");
          return newWords;
        }
        return prev;
      });
    }
  };

  // Game over condition
  useEffect(() => {
    if (misses >= 3) {
      setGameOver(true);
    }
  }, [misses]);

  const resetGame = () => {
    setWords([]);
    setInput("");
    setMisses(0);
    setScore(0);
    setGameOver(false);
  };

  return (
    <div className="game-wrapper">
      {!gameStarted ? (
        <div className="start-screen">
          <h2>Type Fast Words </h2>
          <p>Type the falling words before they reach the bottom.</p>
          <p>You get 3 chances. Miss 3 words and it’s game over!</p>
          <p> Words get faster as your score increases.</p>
          <button className="start-btn" onClick={() => setGameStarted(true)}>
            Start Game
          </button>
        </div>
      ) : (
        <div className="game-container" ref={containerRef}>
          <h2>Type Fast Words </h2>

          {gameOver ? (
            <div className="game-over">
              <h3> Game Over!</h3>
              <button onClick={resetGame}>Play Again</button>
            </div>
          ) : (
            <div className="words-layer">
              {words.map((w) => (
                <div
                  key={w.id}
                  className="falling-word"
                  style={{ top: `${w.y}px`, left: `${w.x}%` }}
                >
                  {w.word}
                </div>
              ))}
            </div>
          )}

          <div className="bottom-panel">
            <p>
              Score: {score} | Misses: {misses} / 3
            </p>
            <input
              className="input-box"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={handleKeyDown}
              disabled={gameOver}
              placeholder="Type word here..."
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default TypeFastWord;
